import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { MComplexInputComponent } from './complex-input.component';
import { MDetailTitleComponent } from './detail-title.component';
import { MGoBackComponent } from './go-back.component';
import { MSearchInputComponent } from './search-input.component';

@NgModule({
  imports: [CommonModule, FormsModule, NzIconModule, NzInputModule, NzButtonModule, NzFormModule, ReactiveFormsModule],
  declarations: [MGoBackComponent, MSearchInputComponent, MDetailTitleComponent, MComplexInputComponent],
  exports: [MGoBackComponent, MSearchInputComponent, MDetailTitleComponent, MComplexInputComponent]
})
export class MWidgetsModule {}
